const carousels = {
  sliders: [],
  init() {
    console.log('Carousels init');
    this.setUpListeners();
  },

  setUpListeners() {
    PubSub.subscribe('embla.init', this.processCarousels.bind(this));
    PubSub.subscribe('embla.slideTo', this.processSlideTo.bind(this));
    this.observer = new IntersectionObserver(this.handleObserveEvent.bind(this));
  },

  processCarousels(eventName, {name, $els, options, plugins}) {
    // if dragFree is not set force it to true
    if (!('dragFree' in options)) {
      options.dragFree = true;
    }

    if ($els && $els instanceof NodeList && $els.length) {
      console.log('Setting up carousels observers...', name);

      $els.forEach($el => {
        $el.options = options;
        $el.plugins = plugins;
        this.observer.observe($el);
      });
    } else if ($els && $els instanceof Node) {
      console.log('Setting up carousel observer...', name);
      $els.options = options;
      $els.plugins = plugins;
      this.observer.observe($els);
    }
  },

  initCarousel($block) {
    $block.embla = EmblaCarousel(
      $block.querySelector('.embla__viewport'),
      $block.options,
      $block.plugins
    );

    this.sliders.push($block.embla);
  },

  processSlideTo(eventName, {$el}) {
    if (this.sliders.length) {
      this.sliders.forEach(slider => {
        slider.slideNodes().forEach(($slide, index) => {
          if ($slide === $el) {
            slider.scrollTo(index);
          }
        })
      });
    }
  },

  setUpCarouselListeners($block) {
    const $prevBtn = $block.querySelector('.prev');
    const $nextBtn = $block.querySelector('.next');
    const $dots = $block.querySelector('.embla__dots');

    if (!$block.embla) {
      return;
    }

    if ($prevBtn) {
      $prevBtn.addEventListener('click', () => {
        $block.embla.scrollPrev();
        this.stopAutoscroll($block);
      }, false);
    }

    if ($nextBtn) {
      $nextBtn.addEventListener('click', () => {
        $block.embla.scrollNext();
        this.stopAutoscroll($block);
      }, false);
    }

    if ($prevBtn && $nextBtn) {
      $block.embla
        .on('init', this.checkPrevNext.bind($block))
        .on('reInit', this.checkPrevNext.bind($block))
        .on('select', this.checkPrevNext.bind($block));
    }

    if ($dots) {
      $block.embla
        .on('init', this.addPagingHandlers.bind($block))
        .on('reInit', this.addPagingHandlers.bind($block));

      $block.embla
        .on('init', this.checkPaging.bind($block))
        .on('reInit', this.checkPaging.bind($block))
        .on('select', this.checkPaging.bind($block));
    }
  },

  addPagingHandlers() {
    const $dotsWrapper = this.querySelector('.embla__dots');

    if ($dotsWrapper) {
      $dotsWrapper.innerHTML = this.embla
        .scrollSnapList()
        .map(() => '<button class="embla__dot" type="button"></button>')
        .join('');

      const scrollTo = (index) => {
        carousels.stopAutoscroll(this);
        this.embla.scrollTo(index);
      };

      const $dots = Array.from($dotsWrapper.querySelectorAll('.embla__dot'));
      $dots.forEach(($dot, index) => {
        $dot.addEventListener('click', () => scrollTo(index), false)
      });
    }
  },

  checkPaging() {
    const $dotsWrapper = this.querySelector('.embla__dots');

    if ($dotsWrapper) {
      const $dots = Array.from($dotsWrapper.querySelectorAll('.embla__dot'));
      const previous = this.embla.previousScrollSnap();
      const selected = this.embla.selectedScrollSnap();
      $dots[previous].classList.remove('embla__dot--selected');
      $dots[selected].classList.add('embla__dot--selected');
    }
  },

  checkPrevNext() {
    const $prev = this.querySelector('.prev');
    const $next = this.querySelector('.next');

    if (!this.embla.canScrollPrev()) {
      $prev.classList.add('disabled');
    } else if ($prev.classList.contains('disabled')) {
      $prev.classList.remove('disabled');
    }

    if (!this.embla.canScrollNext()) {
      $next.classList.add('disabled');
    } else if ($next.classList.contains('disabled')) {
      $next.classList.remove('disabled');
    }
  },

  destroyCarousels() {
    console.log('Destroying carousels');
  },

  startAutoscroll($block) {
    const autoScroll = $block?.embla?.plugins()?.autoScroll;
    const autoplay = $block?.embla?.plugins()?.autoplay;

    if (autoScroll) {
      autoScroll.play();
    }

    if (autoplay) {
      autoplay.play();
    }
  },

  stopAutoscroll($block) {
    const autoScroll = $block?.embla?.plugins()?.autoScroll;
    const autoplay = $block?.embla?.plugins()?.autoplay;

    if (autoScroll) {
      autoScroll.stop();
    }

    if (autoplay) {
      autoplay.stop();
    }
  },

  handleObserveEvent(entries) {
    entries.forEach(({isIntersecting, target}) => {
      if (isIntersecting && !target.embla) {
        this.initCarousel(target);
        this.setUpCarouselListeners(target);
        console.log('Carousel initialized...', target);
      }

      if (isIntersecting) {
        this.startAutoscroll(target);
      } else {
        this.stopAutoscroll(target);
      }
    });
  }
};

export default carousels;